module.exports = __webpack_public_path__ + "img/fourth_wind_ye.178f7f4c.png";